import { render, staticRenderFns } from "./communitylssueUp.vue?vue&type=template&id=cb12148e&scoped=true&"
import script from "./communitylssueUp.vue?vue&type=script&lang=js&"
export * from "./communitylssueUp.vue?vue&type=script&lang=js&"
import style0 from "./communitylssueUp.vue?vue&type=style&index=0&id=cb12148e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb12148e",
  null
  
)

export default component.exports